var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-pink-400 head" }, [
    _c("div", { staticClass: "carousel-container" }, [
      _c("img", {
        staticClass: "carousel_transform",
        class: { "carousel_transform--loaded": _vm.bannerLoaded },
        attrs: { src: _vm.banner, loading: "lazy", decoding: "async", alt: "" },
        on: {
          load: function ($event) {
            _vm.bannerLoaded = true
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }